import {
	ADMINGETKYCPROOFLIST_SUCCESS,
	ADMINGETKYCPROOFLIST_FAILED,
	RESET_ADMINGETKYCPROOFLIST,
	LOADING_ADMINGETKYCPROOFLIST,
	NETWORK_ERROR_ADMINGETKYCPROOFLIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetkycProofList = () => {
	return { type: RESET_ADMINGETKYCPROOFLIST };
};

const adminGetkycProofList = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETKYCPROOFLIST });
	await adminServices
		.post("getKycProofTypeList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetkycProofListsuccess(res.data));
					break;
				default:
					dispatch(adminGetkycProofListFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETKYCPROOFLIST,
				payload: err
			});
		});
};
function adminGetkycProofListsuccess(data) {
	return {
		type: ADMINGETKYCPROOFLIST_SUCCESS,
		payload: data
	};
}
function adminGetkycProofListFailed(data) {
	return {
		type: ADMINGETKYCPROOFLIST_FAILED,
		payload: data
	};
}

export { resetAdminGetkycProofList, adminGetkycProofList };
